import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import ServiceConfigPage from '@/pages/service-config-page'
import AiconConfigPage from '@/pages/aicon-config-page'

export const Route = createFileRoute(
  '/aicon-config-toremove-cause-it-removed-from-separate-tab/$configName',
)({
  component: Component,
})

function Component() {
  const { configName } = Route.useParams()
  return <AiconConfigPage config={configName} />
}
